(() => {
  angular
    .module('app.campaign')
    .controller('CampaignTargetGroupController', CampaignTargetgroup);

  CampaignTargetgroup.$inject = [
    '$scope',
    'ModalService',
    'CountriesService',
    'CustomSegmentsService',
    'CampaignManagerService'
  ];

  function CampaignTargetgroup(
    $scope,
    ModalService,
    CountriesService,
    CustomSegmentsService,
    CampaignManagerService
  ) {
    // because of route configuration, Account Data is already resolved by the time this is called
    const vm = this;
    vm.MAX_CUSTOM_SEGMENTS = 5;
    vm.segmentAvailable = {};
    vm.campaign = CampaignManagerService.getCampaignData();

    let customSegmentsConfirmShowed = false;

    const defaultCountryData = {
      data: ['0', '30000', '60000', '112500', '150000'],
      currencycode: 'USD',
      name: 'Default'
    };

    // Note: this is not the same as the 'criteria' array from the backend.
    // There are 5 income brackets in the criterion array, which makes for 6 'boundaries'
    // for the range slider
    vm.incomeRange = [];
    if (vm.campaign.target && vm.campaign.target.criteria && vm.campaign.target.criteria.income) {
      vm.incomeRange = CountriesService.incomeCriterionToRange(vm.campaign.target.criteria.income);
    }

    CampaignManagerService.countriesPromise.then((response) => {
      vm.countries = response.data;
    });

    vm.isStandardCampaign = () => vm.campaign && vm.campaign.type === 'standard';
    vm.isYouTubeCampaign = () => vm.campaign && vm.campaign.sources.some(item => item.provider === 'adh');

    //object to take care of localization of income
    vm.localization = {
      getCountryInformation: function () {
        if (!angular.isUndefined(vm.campaign)) {
          var country = _.find(vm.countries, (country) => country.isoCode === vm.campaign.panel_country);
          return angular.isUndefined(country) ? defaultCountryData : {
            data: country.incomeBrackets,
            currencycode: country.currencyCode,
            suffix: country.currencySuffix
          };
        }
        return defaultCountryData;
      }
    };

  /* ******************************************************************************* */
  /* ******************************** CustomSegments ******************************* */
  /* ******************************************************************************* */

    vm.customSegments = {
      list: vm.campaign.customSegments,

      getSegmentValues: segment => segment.valueLabels.data.reduce((memo, item) => (
        _.contains(vm.campaign.targetSegment[segment.csid], item.value) ? [...memo, item.value] : memo), []),

      updateAvailableSegments: () => {
        vm.campaign.customSegments.forEach(segment => {
          const { csid } = segment;
          const { c_start, panel_country, start, } = vm.campaign;
          vm.segmentAvailable[csid] = true;

          const promise = CustomSegmentsService.isAvailable({
            csid,
            startDate: start ? new Date(start) : (c_start ? new Date(c_start) : new Date()),
            countryCode: panel_country
          }).$promise;

          promise.then(({ data }) => {
            vm.segmentAvailable[csid] = data && data.available;
          });
        });
      },

      removeSegment: segment => {
        vm.customSegments.list = vm.campaign.customSegments.filter(item => item.csid !== segment.csid);
        vm.campaign.customSegments = vm.customSegments.list;
        delete vm.campaign.targetSegment[segment.csid];

        CampaignManagerService.setCampaignData(vm.campaign);
      },

      toggleTarget: (target, csid) => {
        let targets = vm.campaign.targetSegment;
        if (_.isArray(targets)) {
          targets = {};
        }

        if (_.contains(targets[csid], target.value)) {
          if (targets[csid].length > 1) {
            if (customSegmentsConfirmShowed) {
              targets[csid] = targets[csid].filter(value => value !== target.value);
            } else {
              customSegmentsConfirmShowed = true;
              showCustomSegmentsConfirm(targets, target, csid);
            }
          }
        } else {
          if (!targets[csid]) {
            targets[csid] = [];
          }
          targets[csid].push(target.value);
        }
      },

      checked: (target, csid) => {
        const targets = vm.campaign.targetSegment;
        return _.contains(targets[csid], target.value);
      },
    };

    function showCustomSegmentsConfirm(targets, target, csid) {
      ModalService
        .showModal({
          templateUrl: '../../assets/js/app/components/customSegments/customSegmentsConfirm.html',
          controller: 'CustomSegmentsConfirmController',
          controllerAs: 'csConfirm',
        }).then(modal => {
          modal.element.modal();
          modal.close.then(result => {
            targets[csid] = targets[csid].filter(value => value !== target.value);
          });
        });
    }

    /* Persist changes to service */
    $scope.$watch(() => vm.campaign,
      campaign => {
        if (campaign) {
          vm.customSegments.list = campaign.customSegments;
          CampaignManagerService.setCampaignData(campaign);
        }
      }, true);

    $scope.$watch(() => (vm.campaign && vm.campaign.target && vm.campaign.target.criteria),
      dirty => {
        if (dirty) {
          vm.dirtyCriteria = CampaignManagerService.dirtyCriteria();
        }
      }, true);

    $scope.$watch(() => (vm.campaign && vm.campaign.targetSegment),
      dirty => {
        if (dirty) {
          vm.dirtyTargets = CampaignManagerService.dirtyTargets();
          vm.customSegments.updateAvailableSegments();
        }
      }, true);

    $scope.$watch(() => vm.incomeRange,
      newIncomeRange => {
        // Set the income criterion on the campaign before saving, since the range slider in the Create/Edit
        // interface uses the vm.incomeRange model instead of the campaign.target.... model
        if (newIncomeRange) {
          if (vm.campaign.target) {
            vm.campaign.target.criteria.income = CountriesService.rangeToIncomeCriterion(newIncomeRange);
          }
          CampaignManagerService.setCampaignData(vm.campaign);
        }
      }, true);
  }
})();
